import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _taggedTemplateLiteral from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

// @ts-ignore

/* eslint-disable */
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
var defaultOptions = {};
export var SavedPaymentMethodFragmentFragmentDoc = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    fragment SavedPaymentMethodFragment on SavedPaymentMethod {\n  __typename\n  id\n  token\n  type\n  description\n  iconName\n  cardMaskedNumber\n  cardExpiryMonth\n  cardExpiryYear\n}\n    "])));
export var AddPaymentMethodDocument = gql(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    mutation AddPaymentMethod($setupIntentId: String!, $setAsDefault: Boolean) {\n  addPaymentMethod(\n    input: {setupIntentId: $setupIntentId, setAsDefault: $setAsDefault}\n  ) {\n    paymentMethods {\n      ...SavedPaymentMethodFragment\n    }\n  }\n}\n    ", ""])), SavedPaymentMethodFragmentFragmentDoc);
/**
 * __useAddPaymentMethodMutation__
 *
 * To run a mutation, you first call `useAddPaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPaymentMethodMutation, { data, loading, error }] = useAddPaymentMethodMutation({
 *   variables: {
 *      setupIntentId: // value for 'setupIntentId'
 *      setAsDefault: // value for 'setAsDefault'
 *   },
 * });
 */

export function useAddPaymentMethodMutation(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useMutation(AddPaymentMethodDocument, options);
}
export var CreateSetupIntentDocument = gql(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    mutation CreateSetupIntent {\n  createSetupIntent {\n    setupIntentId\n    clientSecret\n  }\n}\n    "])));
/**
 * __useCreateSetupIntentMutation__
 *
 * To run a mutation, you first call `useCreateSetupIntentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSetupIntentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSetupIntentMutation, { data, loading, error }] = useCreateSetupIntentMutation({
 *   variables: {
 *   },
 * });
 */

export function useCreateSetupIntentMutation(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useMutation(CreateSetupIntentDocument, options);
}
export var RemovePaymentMethodDocument = gql(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    mutation RemovePaymentMethod($paymentMethodId: ID!) {\n  removePaymentMethod(input: {paymentMethodId: $paymentMethodId}) {\n    paymentMethods {\n      ...SavedPaymentMethodFragment\n    }\n  }\n}\n    ", ""])), SavedPaymentMethodFragmentFragmentDoc);
/**
 * __useRemovePaymentMethodMutation__
 *
 * To run a mutation, you first call `useRemovePaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePaymentMethodMutation, { data, loading, error }] = useRemovePaymentMethodMutation({
 *   variables: {
 *      paymentMethodId: // value for 'paymentMethodId'
 *   },
 * });
 */

export function useRemovePaymentMethodMutation(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useMutation(RemovePaymentMethodDocument, options);
}
export var SavedPaymentMethodsDocument = gql(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    query SavedPaymentMethods {\n  customer {\n    paymentDetails {\n      savedPaymentMethods {\n        ...SavedPaymentMethodFragment\n      }\n    }\n  }\n}\n    ", ""])), SavedPaymentMethodFragmentFragmentDoc);
/**
 * __useSavedPaymentMethodsQuery__
 *
 * To run a query within a React component, call `useSavedPaymentMethodsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSavedPaymentMethodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSavedPaymentMethodsQuery({
 *   variables: {
 *   },
 * });
 */

export function useSavedPaymentMethodsQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useQuery(SavedPaymentMethodsDocument, options);
}
export function useSavedPaymentMethodsLazyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useLazyQuery(SavedPaymentMethodsDocument, options);
}
export function useSavedPaymentMethodsSuspenseQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useSuspenseQuery(SavedPaymentMethodsDocument, options);
}
export var UpdatePaymentMethodDocument = gql(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    mutation UpdatePaymentMethod($setupIntentId: String!, $paymentMethodId: String!, $setAsDefault: Boolean) {\n  updatePaymentMethod(\n    input: {setupIntentId: $setupIntentId, paymentMethodId: $paymentMethodId, setAsDefault: $setAsDefault}\n  ) {\n    paymentMethods {\n      ...SavedPaymentMethodFragment\n    }\n  }\n}\n    ", ""])), SavedPaymentMethodFragmentFragmentDoc);
/**
 * __useUpdatePaymentMethodMutation__
 *
 * To run a mutation, you first call `useUpdatePaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePaymentMethodMutation, { data, loading, error }] = useUpdatePaymentMethodMutation({
 *   variables: {
 *      setupIntentId: // value for 'setupIntentId'
 *      paymentMethodId: // value for 'paymentMethodId'
 *      setAsDefault: // value for 'setAsDefault'
 *   },
 * });
 */

export function useUpdatePaymentMethodMutation(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useMutation(UpdatePaymentMethodDocument, options);
}